import FileExplorer from './FilePreview';

export default FileExplorer;
